/**
 * ScrollDown
 *
 * @since 1.0.0
 */

import Smooth from 'smoothscroll'

const ScrollDown = () => {
  const buttons = document.querySelectorAll('.js-scroll-down')
  if (buttons) {
    [...buttons].forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault()
        const { target } = e.target.dataset
        const hero = document.getElementById(target)
        let height = hero.clientHeight + 60
        Smooth(height, 1000)
      })
    })
  }
}

export default ScrollDown



// WEBPACK FOOTER //
// ./src/js/modules/ScrollDown.js